module.exports = __webpack_public_path__ + "img/pocket-7_jp.6b03d83.jpg";